import React from 'react';
import AuthenticationHeader from '../../../components/ui/AuthenticationHeader';

const AuthenticationLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <AuthenticationHeader showHelp={true} />
      {/* Main Content */}
      <main className="pt-16 pb-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center min-h-[calc(100vh-8rem)]">
            {children}
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="fixed bottom-0 right-0 left-0 bg-background border-t border-border py-4 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between text-sm text-muted-foreground">
            <div className="flex items-center space-x-reverse space-x-4 mb-2 sm:mb-0">
              <span>© {new Date()?.getFullYear()} ایران‌داد </span>
              <span>•</span>
              <span>تمامی حقوق محفوظ است</span>
            </div>
            <div className="flex items-center space-x-reverse space-x-4">
              <button className="hover:text-foreground transition-smooth">
                حریم خصوصی
              </button>
              <span>•</span>
              <button className="hover:text-foreground transition-smooth">
                شرایط استفاده
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthenticationLayout;
